import type { StrapiModuleOptions } from '@nimbus/types'
import { useNimbusConfig } from '#imports'

export const useStrapiConfig = (): StrapiModuleOptions => {
    const { strapi } = useNimbusConfig()

    return strapi as StrapiModuleOptions
}
